import { PropType, computed, defineComponent } from "vue";
import Utils from "../utils/Utils";
import Tracking from "../utils/Tracking";
import { Links } from "../utils/Links";
import OfferUtils, { OfferCode, OfferCodeItem, OfferTariff, OfferUi } from "../utils/OfferUtils";
import { OfferJson } from "../OrderForm";
import ReIcon from "./ReIcon";

enum Type {
    FEATURED = 'featured',
    INFO = 'info',
}

enum Sticky {
    AUTO = 'auto',
    ALWAYS = 'always',
}

const OfferBoxPriceBox = defineComponent({
    template: `
        <div class="OfferBox__pricebox">
            <div v-if="offer.prices.length == 1" class="OfferBox__prices OfferBox__prices--one">
                <div class="OfferBox__price">
                    <div class="OfferBox__price-value" v-html="splitformat(priceformat(offer.prices[0].price, false))"></div>

                    <div class="OfferBox__price-unit">
                        <b>zł/kWh</b>
                        z VAT
                    </div>
                </div>
            </div>

            <div v-if="offer.prices.length > 1" class="OfferBox__pricebox-wrap">
                <div class="OfferBox__prices OfferBox__prices--multi">
                    <div v-for="price,k in offer.prices" class="OfferBox__price">
                        <div v-if="offer.prices.length > 1" class="OfferBox__price-icon">
                            <svg v-if="k == 0" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                <path d="M12.5 23.0461V19.8733" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.97696 21.5668L8.56682 18.8157" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.93318 17.523L5.68433 15.9331" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1.45392 12H4.63364" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.93318 6.47705L5.68433 8.06691" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.97696 2.43311L8.56682 5.18426" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.5 0.953857V4.13358" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.023 2.43311L16.4332 5.18426" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M22.0668 6.47705L19.3157 8.06691" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.5461 12H20.3664" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M22.0668 17.523L19.3157 15.9331" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.023 21.5668L16.4332 18.8157" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.6889 12C16.6889 14.3156 14.8157 16.1889 12.5 16.1889C10.1843 16.1889 8.31107 14.3156 8.31107 12C8.31107 9.68431 10.1843 7.81104 12.5 7.81104C14.8157 7.81104 16.6889 9.68431 16.6889 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <svg v-if="k == 1 && offer.tariff == 'G12'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M10.4757 22.765C10.7372 22.8177 11.0062 22.8554 11.2752 22.8855C15.2877 23.3449 18.9489 21.7258 21.34 18.9545C21.1905 18.7211 21.2055 18.7512 21.056 18.5178C19.4271 19.1202 17.6339 19.3537 15.7659 19.1428C14.929 19.0524 14.1071 18.8566 13.33 18.5855C9.5193 17.2602 6.26899 13.9843 5.74595 9.86511C5.29763 6.36338 5.03611 3.80298 6.81444 1.1748C2.89913 3.44904 0.440844 7.97493 1.15068 12.9978C1.62889 16.4092 3.64632 19.3762 6.44084 21.161" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.2902 12.4933C17.2902 9.52628 14.5554 6.76256 11.604 6.76256C14.5479 6.76256 17.2902 4.00636 17.2902 1.03931C17.2902 4.00636 20.0249 6.76256 22.9763 6.76256C20.0324 6.76256 17.2902 9.51875 17.2902 12.4933Z" stroke="currentColor" stroke-width="2.76" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <svg v-if="k == 1 && offer.tariff == 'G12w'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M10.3401 10.93H3.2001V9.69005C3.2001 9.08005 3.6901 8.59005 4.3001 8.59005H5.6901V8.97005C5.6901 9.41005 6.0501 9.77005 6.4901 9.77005C6.9301 9.77005 7.2901 9.41005 7.2901 8.97005V8.59005H9.1101C9.5501 8.59005 9.9101 8.23005 9.9101 7.79005C9.9101 7.35005 9.5501 6.99005 9.1101 6.99005H7.2901V5.35005C7.2901 4.91005 6.9301 4.55005 6.4901 4.55005C6.0501 4.55005 5.6901 4.91005 5.6901 5.35005V6.99005H4.3001C2.8101 6.99005 1.6001 8.20005 1.6001 9.69005V20.3C1.6001 21.79 2.8101 23 4.3001 23H17.5801C19.0701 23 20.2801 21.79 20.2801 20.3V14.69C20.2801 14.25 19.9201 13.89 19.4801 13.89C19.0401 13.89 18.6801 14.25 18.6801 14.69V20.3C18.6801 20.91 18.1901 21.4 17.5801 21.4H4.2901C3.6901 21.4 3.1901 20.91 3.1901 20.3V12.53H10.3401C10.7801 12.53 11.1401 12.17 11.1401 11.73C11.1401 11.29 10.7801 10.93 10.3401 10.93Z" fill="white"/>
                                <path d="M7.89996 15.66C8.24996 15.69 8.57996 15.44 8.61996 15.08C8.65996 14.72 8.39996 14.4 8.04996 14.36C6.96996 14.24 5.58996 14.59 5.10996 16.93C4.94996 17.71 5.02996 18.49 5.31996 19.13C5.63996 19.84 6.19996 20.32 6.86996 20.45C7.00996 20.48 7.13996 20.49 7.27996 20.49C7.67996 20.49 8.07996 20.37 8.41996 20.13C8.86996 19.82 9.17996 19.35 9.28996 18.81C9.39996 18.27 9.28996 17.72 8.99996 17.25C8.69996 16.78 8.23996 16.46 7.69996 16.35C7.32996 16.27 6.94996 16.31 6.59996 16.43C6.92996 15.66 7.41996 15.58 7.90996 15.63L7.89996 15.66ZM6.81996 17.81C6.98996 17.66 7.21996 17.6 7.43996 17.64C7.62996 17.68 7.78996 17.79 7.89996 17.96C8.00996 18.13 8.04996 18.35 8.00996 18.56C7.96996 18.77 7.84996 18.95 7.67996 19.07C7.50996 19.18 7.31996 19.22 7.12996 19.18C6.90996 19.13 6.74996 18.98 6.63996 18.82C6.63996 18.79 6.61996 18.77 6.60996 18.74C6.54996 18.59 6.52996 18.42 6.55996 18.26C6.59996 18.08 6.68996 17.92 6.82996 17.8L6.81996 17.81Z" fill="white"/>
                                <path d="M13.2801 20.2899C13.3701 20.3299 13.4701 20.3599 13.5701 20.3599C13.8101 20.3599 14.0401 20.2299 14.1501 19.9899L16.4001 15.3799C16.5001 15.1799 16.4901 14.9399 16.3701 14.7499C16.2501 14.5599 16.0401 14.4399 15.8201 14.4399H13.0001C12.6401 14.4399 12.3501 14.7299 12.3501 15.0899C12.3501 15.4499 12.6401 15.7399 13.0001 15.7399H14.7801L12.9801 19.4099C12.8201 19.7299 12.9601 20.1199 13.2801 20.2799V20.2899Z" fill="white"/>
                                <path d="M10.9698 16.84C10.6098 16.84 10.3198 17.13 10.3198 17.49C10.3198 17.85 10.6098 18.14 10.9698 18.14H12.0398C12.3998 18.14 12.6898 17.85 12.6898 17.49C12.6898 17.13 12.3998 16.84 12.0398 16.84H10.9698Z" fill="white"/>
                                <path d="M16.9298 1.01001C13.5498 1.01001 10.7998 3.76001 10.7998 7.14001C10.7998 10.52 13.5498 13.27 16.9298 13.27C20.3098 13.27 23.0598 10.52 23.0598 7.14001C23.0598 3.76001 20.3098 1.01001 16.9298 1.01001ZM16.9298 11.67C14.4298 11.67 12.3998 9.64001 12.3998 7.14001C12.3998 4.64001 14.4298 2.61001 16.9298 2.61001C19.4298 2.61001 21.4598 4.64001 21.4598 7.14001C21.4598 9.64001 19.4298 11.67 16.9298 11.67Z" fill="white"/>
                                <path d="M18.7099 5.35989L17.7299 5.84989V3.93989C17.7299 3.49989 17.3699 3.13989 16.9299 3.13989C16.4899 3.13989 16.1299 3.49989 16.1299 3.93989V7.13989C16.1299 7.41989 16.2699 7.67989 16.5099 7.81989C16.6399 7.89989 16.7799 7.93989 16.9299 7.93989C17.0499 7.93989 17.1699 7.90989 17.2899 7.85989L19.4199 6.78989C19.8199 6.58989 19.9799 6.10989 19.7799 5.71989C19.5799 5.32989 19.0999 5.15989 18.7099 5.35989Z" fill="white"/>
                            </svg>
                        </div>

                        <div class="OfferBox__price-val">
                            <b>{{ priceformat(price.price, false, 4) }}</b>
                            <span>zł/kWh z VAT</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,

    props: {
        offer: { type: Object as PropType<OfferJson>, require: true },
    },

    setup(props, ctx) {
        function splitformat(val: any) {
            const parts: string[] = val.toString().split('');

            return '<span>' + parts.join('</span><span>') + '</span>';
        }

        function priceformat(price, rounded, r = 4) {
            return Utils.priceFormat(price, rounded, '', r);
        }

        return {
            splitformat,
            priceformat,
        };
    },
});

const OfferBoxWarranty = defineComponent({
    components: {
        ReIcon,
    },

    template: `
        <div class="OfferBox__warranty">
            <ReIcon v-if="codeitem?.ui.offerGuarantee?.icon" class="OfferBox__warranty-icon" :icon="codeitem?.ui.offerGuarantee?.icon" />

            <div v-else class="OfferBox__warranty-icon">
                <svg v-if="offer.price_warranty == 24" xmlns="http://www.w3.org/2000/svg" width="27" height="31" viewBox="0 0 27 31" fill="none">
                    <path d="M23.2133 20.4867C23.76 20.7133 24.3867 20.46 24.6 19.9133C26.56 15.18 26.8533 10.2067 26.8667 7.66C26.8667 5.88667 25.7467 4.3 24.0667 3.71333L13.8 0.06C13.5733 -0.02 13.32 -0.02 13.08 0.06L2.8 3.7C1.12 4.28667 0 5.88667 0 7.64667C0 13.1133 1.30667 26.3 13.0533 30.7267C13.1733 30.7667 13.3067 30.7933 13.4267 30.7933C13.5467 30.7933 13.68 30.7667 13.8 30.7267C16.9733 29.54 19.6267 27.5933 21.72 24.9267L22.6667 23.6467C23.0133 23.1667 22.9067 22.5 22.44 22.1533C21.96 21.8067 21.2933 21.9133 20.9467 22.38L20.0267 23.6333C18.28 25.86 16.0667 27.5267 13.4267 28.58C3.28 24.4867 2.14667 12.6067 2.13333 7.64667C2.13333 6.78 2.68 5.99333 3.50667 5.71333L13.4267 2.19333L23.3467 5.71333C24.1733 6.00667 24.72 6.78 24.72 7.64667C24.72 10.0333 24.44 14.7 22.6133 19.1C22.3867 19.6467 22.6533 20.2733 23.1867 20.4867H23.2133Z" fill="currentColor"/>
                    <path d="M10.1733 20.95H16.6933C17.28 20.95 17.76 20.47 17.76 19.8833C17.76 19.2967 17.28 18.8167 16.6933 18.8167H12.48L16.5333 14.07C17.96 12.4033 17.8533 9.89667 16.3067 8.35L16.1867 8.23C14.5467 6.59 11.8667 6.59 10.2267 8.23C9.45333 9.00333 9.01333 10.03 9 11.1233C9 11.71 9.45333 12.2033 10.04 12.2167C10.6267 12.19 11.12 11.7633 11.1333 11.1767C11.1333 10.6433 11.36 10.1367 11.7467 9.75C12.56 8.93667 13.88 8.93667 14.6933 9.75L14.8133 9.87C15.5733 10.63 15.6267 11.87 14.92 12.6967L9.36 19.2033C9.09333 19.5233 9.02667 19.9633 9.2 20.35C9.37333 20.7233 9.74667 20.9633 10.1733 20.9633V20.95Z" fill="currentColor"/>
                </svg>

                <svg v-if="offer.price_warranty == 36" xmlns="http://www.w3.org/2000/svg" width="27" height="31" viewBox="0 0 27 31" fill="none">
                    <path d="M23.2133 20.4867C23.76 20.7133 24.3867 20.46 24.6 19.9133C26.56 15.18 26.8533 10.2067 26.8667 7.66C26.8667 5.88667 25.7467 4.3 24.0667 3.71333L13.8 0.06C13.5733 -0.02 13.32 -0.02 13.08 0.06L2.8 3.7C1.12 4.28667 0 5.88667 0 7.64667C0 13.1133 1.30667 26.3 13.0533 30.7267C13.1733 30.7667 13.3067 30.7933 13.4267 30.7933C13.5467 30.7933 13.68 30.7667 13.8 30.7267C16.9733 29.54 19.6267 27.5933 21.72 24.9267L22.6667 23.6467C23.0133 23.1667 22.9067 22.5 22.44 22.1533C21.96 21.8067 21.2933 21.9133 20.9467 22.38L20.0267 23.6333C18.28 25.86 16.0667 27.5267 13.4267 28.58C3.28 24.4867 2.14667 12.6067 2.13333 7.64667C2.13333 6.78 2.68 5.99333 3.50667 5.71333L13.4267 2.19333L23.3467 5.71333C24.1733 6.00667 24.72 6.78 24.72 7.64667C24.72 10.0333 24.44 14.7 22.6133 19.1C22.3867 19.6467 22.6533 20.2733 23.1867 20.4867H23.2133Z" fill="currentColor"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3273 20.949L12.3034 20.943C12.2599 20.9321 12.2288 20.932 12.1989 20.932C12.0381 20.932 11.3319 20.8764 10.4728 20.5085C9.51897 20.1196 8.72304 19.4654 8.17408 18.6508L8.17239 18.6483C7.85773 18.1658 7.98486 17.5179 8.46372 17.1848L8.46863 17.1814C8.94844 16.8685 9.59967 16.9908 9.91745 17.4762C10.2519 17.9694 10.696 18.3346 11.2881 18.5747L11.2937 18.5769C11.5659 18.697 11.8142 18.7612 11.9938 18.7951C12.0834 18.812 12.1555 18.8214 12.2042 18.8264C12.2286 18.829 12.247 18.8304 12.2589 18.8312L12.2717 18.832C12.3166 18.8324 12.3594 18.8377 12.3899 18.8416L12.3937 18.842C12.4299 18.8466 12.4515 18.849 12.4709 18.849C12.584 18.849 13.0222 18.849 13.5573 18.703L13.5649 18.701C13.9914 18.6026 14.5629 18.3927 14.9673 18.0038L14.9705 18.0008C15.3502 17.6515 15.5349 17.214 15.5349 16.635C15.5349 16.032 15.3627 15.5976 15.0048 15.2694L15.0031 15.2679C14.5081 14.8038 13.714 14.6057 13.1083 14.5214C12.4872 14.4476 11.977 14.4661 11.8407 14.471C11.8327 14.4713 11.826 14.4715 11.8207 14.4717C11.4006 14.5106 10.9851 14.2806 10.7961 13.9024L10.7941 13.8986C10.6082 13.5061 10.6676 13.0437 10.9638 12.7255L14.2626 9.1H9.47894C8.89248 9.1 8.42894 8.63646 8.42894 8.05C8.42894 7.46354 8.89248 7 9.47894 7H16.6359C17.0564 7 17.4332 7.25185 17.6007 7.62877C17.7681 8.00548 17.7057 8.44818 17.412 8.76357L17.4111 8.76446L13.9657 12.5434C14.9677 12.754 15.8007 13.1369 16.4132 13.7157C16.8124 14.0615 17.0986 14.4941 17.3105 14.9532L17.3128 14.9582C17.5288 15.4622 17.6349 16.0165 17.6349 16.635C17.6349 17.2375 17.5284 17.7929 17.2944 18.3148L17.2935 18.3168C17.0796 18.7802 16.7933 19.1923 16.4169 19.5508L16.414 19.5535C15.1533 20.7077 13.3251 20.949 12.5559 20.949H12.3273Z" fill="currentColor"/>
                </svg>

                <svg v-if="offer.price_warranty == 60" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M26.2133 21.4867C26.76 21.7133 27.3867 21.46 27.6 20.9133C29.56 16.18 29.8533 11.2067 29.8667 8.66C29.8667 6.88667 28.7467 5.3 27.0667 4.71333L16.8 1.06C16.5733 0.98 16.32 0.98 16.08 1.06L5.8 4.7C4.12 5.28667 3 6.88667 3 8.64667C3 14.1133 4.30667 27.3 16.0533 31.7267C16.1733 31.7667 16.3067 31.7933 16.4267 31.7933C16.5467 31.7933 16.68 31.7667 16.8 31.7267C19.9733 30.54 22.6267 28.5933 24.72 25.9267L25.6667 24.6467C26.0133 24.1667 25.9067 23.5 25.44 23.1533C24.96 22.8067 24.2933 22.9133 23.9467 23.38L23.0267 24.6333C21.28 26.86 19.0667 28.5267 16.4267 29.58C6.28 25.4867 5.14667 13.6067 5.13333 8.64667C5.13333 7.78 5.68 6.99333 6.50667 6.71333L16.4267 3.19333L26.3467 6.71333C27.1733 7.00667 27.72 7.78 27.72 8.64667C27.72 11.0333 27.44 15.7 25.6133 20.1C25.3867 20.6467 25.6533 21.2733 26.1867 21.4867H26.2133Z" fill="currentColor"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5667 21.9659C14.8964 21.9483 14.2123 21.8073 13.5324 21.5632L13.5313 21.5628C12.8124 21.2998 12.1167 20.8987 11.4283 20.4168L11.4205 20.4114C10.9659 20.0601 10.854 19.4101 11.2129 18.943C11.5516 18.48 12.2007 18.3804 12.6772 18.7118L12.6826 18.7156C13.6604 19.4448 14.6929 19.8338 15.6299 19.8661L15.6311 19.8662C16.4198 19.8984 17.1211 19.6734 17.6768 19.2446C18.088 18.9283 18.3859 18.503 18.526 18.0517C18.6653 17.6026 18.6504 17.122 18.4796 16.6706C18.1913 15.9509 17.7519 15.502 17.1451 15.253C16.3337 14.9189 15.3276 14.9946 14.6102 15.1447C14.2202 15.2277 13.8752 15.3316 13.6276 15.4148C13.5039 15.4564 13.4049 15.4927 13.3372 15.5184C13.3033 15.5313 13.2773 15.5415 13.26 15.5485L13.2406 15.5563L13.2362 15.5581C12.9005 15.7041 12.5038 15.6625 12.2087 15.4517C11.9143 15.2414 11.7473 14.8862 11.7683 14.5293L11.7684 14.5275L12.1425 8.98423C12.1842 8.42115 12.6449 8 13.192 8H19.669C20.2554 8 20.719 8.46354 20.719 9.05C20.719 9.63646 20.2554 10.1 19.669 10.1H14.1778L13.9715 13.1359C14.049 13.1184 14.1262 13.103 14.2004 13.0882L14.2067 13.0869C15.6276 12.8096 16.8764 12.8754 17.9413 13.3013L17.9465 13.3034C18.4784 13.5339 18.9587 13.8539 19.3684 14.2636C19.8144 14.7095 20.168 15.2594 20.4316 15.8921L20.4327 15.8947C20.79 16.7879 20.8253 17.7529 20.5401 18.6798L20.5391 18.6831C20.2546 19.5545 19.7207 20.3192 18.9577 20.9047C18.4967 21.2593 17.984 21.5239 17.422 21.7171L17.4145 21.7197C16.8869 21.878 16.3235 21.966 15.759 21.966L15.5667 21.9659Z" fill="currentColor"/>
                </svg>

                <svg v-if="offer.price_warranty == 120" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M26.2133 21.4867C26.76 21.7133 27.3867 21.46 27.6 20.9133C29.56 16.18 29.8533 11.2067 29.8667 8.66C29.8667 6.88667 28.7467 5.3 27.0667 4.71333L16.8 1.06C16.5733 0.98 16.32 0.98 16.08 1.06L5.8 4.7C4.12 5.28667 3 6.88667 3 8.64667C3 14.1133 4.30667 27.3 16.0533 31.7267C16.1733 31.7667 16.3067 31.7933 16.4267 31.7933C16.5467 31.7933 16.68 31.7667 16.8 31.7267C19.9733 30.54 22.6267 28.5933 24.72 25.9267L25.6667 24.6467C26.0133 24.1667 25.9067 23.5 25.44 23.1533C24.96 22.8067 24.2933 22.9133 23.9467 23.38L23.0267 24.6333C21.28 26.86 19.0667 28.5267 16.4267 29.58C6.28 25.4867 5.14667 13.6067 5.13333 8.64667C5.13333 7.78 5.68 6.99333 6.50667 6.71333L16.4267 3.19333L26.3467 6.71333C27.1733 7.00667 27.72 7.78 27.72 8.64667C27.72 11.0333 27.44 15.7 25.6133 20.1C25.3867 20.6467 25.6533 21.2733 26.1867 21.4867H26.2133Z" fill="currentColor"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3996 19.057C15.9433 19.7233 16.5936 20.251 17.3159 20.621C18.0723 21.008 18.8854 21.221 19.7191 21.221C20.5694 21.221 21.3825 21.0082 22.1393 20.621C22.8618 20.2509 23.5123 19.723 24.0561 19.0564C25.1413 17.7262 25.7501 15.9637 25.7501 14.102C25.7501 12.2571 25.1411 10.4947 24.0561 9.16458C23.5127 8.49848 22.8628 7.97085 22.1408 7.60081C21.3802 7.19428 20.5662 7 19.7191 7C18.8886 7 18.0747 7.19444 17.3143 7.6008C16.5926 7.97074 15.9429 8.49816 15.3996 9.16397C14.2961 10.4955 13.7051 12.2587 13.7051 14.102C13.7051 15.9621 14.296 17.7254 15.3996 19.057ZM20.9019 20.8756C20.5173 20.9711 20.1225 21.021 19.7193 21.021C18.9203 21.021 18.1383 20.817 17.4073 20.443C16.7103 20.086 16.0813 19.576 15.5543 18.93C14.4833 17.638 13.9053 15.921 13.9053 14.102C13.9053 12.3 14.4833 10.583 15.5543 9.29095C16.0813 8.64495 16.7103 8.13495 17.4073 7.77795C17.7685 7.58476 18.1421 7.44137 18.5241 7.34573C18.142 7.44137 17.7683 7.58477 17.4071 7.778C16.7101 8.135 16.0811 8.645 15.5541 9.291C14.4831 10.583 13.9051 12.3 13.9051 14.102C13.9051 15.921 14.4831 17.638 15.5541 18.93C16.0811 19.576 16.7101 20.086 17.4071 20.443C18.1381 20.817 18.9201 21.021 19.7191 21.021C20.1223 21.021 20.5173 20.9712 20.9019 20.8756ZM19.7191 19.121C18.7351 19.121 17.7686 18.6293 17.0176 17.7151C16.2351 16.7696 15.8051 15.4898 15.8051 14.102C15.8051 12.7311 16.2347 11.4352 17.0168 10.4899C17.768 9.59193 18.7349 9.1 19.7191 9.1C20.7211 9.1 21.6872 9.59262 22.4203 10.4886L22.421 10.4895C23.2043 11.436 23.6501 12.7326 23.6501 14.102C23.6501 15.488 23.2045 16.7677 22.421 17.7145L22.4192 17.7167C21.6863 18.6288 20.7207 19.121 19.7191 19.121ZM18.9322 8.99844C19.1902 8.93345 19.4536 8.9 19.7191 8.9C20.7901 8.9 21.8101 9.427 22.5751 10.362C23.3911 11.348 23.8501 12.691 23.8501 14.102C23.8501 15.53 23.3911 16.856 22.5751 17.842C21.9999 18.5578 21.2805 19.0334 20.5036 19.2253C21.2805 19.0334 22 18.5578 22.5753 17.842C23.3913 16.856 23.8503 15.53 23.8503 14.102C23.8503 12.691 23.3913 11.348 22.5753 10.362C21.8103 9.42695 20.7903 8.89995 19.7193 8.89995C19.4537 8.89995 19.1903 8.93341 18.9322 8.99844Z" fill="currentColor"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.7385 8.26707C7.18949 8.43617 6.87846 9.02436 7.04485 9.58595L7.04688 9.59238C7.19311 10.0311 7.60956 10.3241 8.05261 10.3241C8.16229 10.3241 8.26986 10.3026 8.37426 10.2618L10.2836 9.66517V19.9161C10.2836 20.5026 10.7472 20.9661 11.3336 20.9661C11.9201 20.9661 12.3836 20.5026 12.3836 19.9161V8.23713C12.3836 7.90003 12.2163 7.58648 11.9637 7.39702L11.9575 7.39269C11.6898 7.20737 11.3366 7.1421 11.0174 7.24772L7.7385 8.26707ZM10.4836 9.39313L8.30761 10.0731C8.22261 10.1071 8.13761 10.1241 8.05261 10.1241C7.69561 10.1241 7.35561 9.88613 7.23661 9.52913C7.10884 9.09788 7.32621 8.65163 7.71954 8.48645C7.32634 8.6517 7.10907 9.09787 7.23683 9.52904C7.35583 9.88604 7.69583 10.124 8.05283 10.124C8.13783 10.124 8.22283 10.107 8.30783 10.073L10.4838 9.39304V19.916C10.4838 20.392 10.8578 20.766 11.3338 20.766C11.4537 20.766 11.5671 20.7423 11.6697 20.6992C11.5671 20.7424 11.4536 20.7661 11.3336 20.7661C10.8576 20.7661 10.4836 20.3921 10.4836 19.9161V9.39313Z" fill="currentColor"/>
                </svg>

                <svg v-if="!offer.price_warranty" xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
                    <path d="M15.2491 25.4349C15.8828 25.4192 16.5165 25.3798 17.1663 25.3169C20.8562 24.9789 23.4392 24.3499 26.2307 22.9975C27.2655 22.4943 28.5169 22.801 29.1666 23.7445C29.9046 24.8137 29.5757 26.2683 28.4527 26.9445C25.3804 28.8079 22.1317 29.8142 17.6315 30.2231C12.8667 30.6634 8.41468 29.9951 4.94934 28.5563" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19.0835 25.0967C20.4953 24.9709 21.5381 23.8387 21.4178 22.565C21.2974 21.3227 20.0942 20.395 18.7064 20.5051C16.3561 20.6859 15.2571 20.7252 13.701 20.5208C11.2704 20.1984 9.16072 22.5336 5.75955 22.5571L2.32629 22.4864" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M22.4846 8.75081C22.4846 12.9886 18.9791 16.4167 14.6635 16.4167C10.3479 16.4167 6.84241 12.9808 6.84241 8.75081C6.84241 4.52083 10.3398 1.08496 14.6635 1.08496C18.9871 1.08496 22.4846 4.52083 22.4846 8.75081Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.7784 11.1252C13.5405 11.8092 14.6074 12.0765 15.6181 11.7227C15.7705 11.6677 15.9229 11.6048 16.0593 11.5262C17.2304 10.8736 16.7572 8.9473 15.4336 8.83723L13.8614 8.71143C12.5378 8.60136 12.0725 6.70652 13.2277 6.02249C13.3881 5.92814 13.5565 5.84952 13.741 5.78662C14.5432 5.51143 15.3775 5.61364 16.0673 6.01463" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1.78075 30.915C1.38769 29.8929 1.10693 27.5105 1.10693 24.7351C1.10693 21.9597 1.37165 19.6717 1.75669 18.6182" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.5031 4.51294V4.85102" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.5031 12.5327V12.8708" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div v-if="codeitem?.ui.offerGuarantee?.text" class="OfferBox__warranty-label">
                {{ codeitem.ui.offerGuarantee.text }}
            </div>

            <template v-else>
                <div v-if="offer.price_warranty" class="OfferBox__warranty-label">
                    Zabezpieczone ceny na lata!
                </div>

                <div v-if="!offer.price_warranty" class="OfferBox__warranty-label">
                    Zawsze najlepsza cena na rynku
                </div>
            </template>
        </div>
    `,

    props: {
        offer: { type: Object as PropType<OfferJson>, require: true },
        codeitem: { type: Object as PropType<OfferCodeItem> },
    },
});

export const OfferBoxParam = defineComponent({
    components: {
        ReIcon,
    },

    template: `
        <div class="OfferBox__param">
            <ReIcon v-if="icon" :icon="icon" />

            <i v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M1.83339 9.87329H7.06006L5.48006 14.7666C5.40672 15 5.50005 15.26 5.71339 15.3866C5.80006 15.44 5.89339 15.4666 5.99339 15.4666C6.13339 15.4666 6.26672 15.4133 6.37339 15.3066L14.5534 7.03995C14.7067 6.88662 14.7467 6.65995 14.6667 6.45995C14.5867 6.25995 14.3867 6.13329 14.1734 6.13329H8.94672L10.5267 1.23995C10.6001 1.00662 10.5067 0.746621 10.2934 0.619954C10.0801 0.493288 9.81339 0.526621 9.64006 0.699954L1.45339 8.95995C1.30006 9.11329 1.26006 9.33995 1.34006 9.53996C1.42006 9.73995 1.62006 9.86662 1.83339 9.86662V9.87329ZM8.81339 3.03995L7.69339 6.49995C7.64006 6.65995 7.66672 6.83995 7.76672 6.97995C7.86672 7.11995 8.02672 7.19995 8.20006 7.19995H12.8867L7.18006 12.9666L8.30006 9.50662C8.35339 9.34662 8.32672 9.16662 8.22672 9.02662C8.12672 8.88662 7.96672 8.80662 7.79339 8.80662H3.10672L8.81339 3.03995Z" fill="currentColor" />
                </svg>
            </i>

            <div v-html="title"></div>
        </div>
    `,

    props: {
        title: { type: String },
        icon: { type: String },
        format: { type: String },
    },
});

export const OfferBoxInfo = defineComponent({
    components: {
        OfferBoxParam,
    },

    template: `
        <div class="OfferBox__info">
            <template v-if="ui">
                <OfferBoxParam v-if="ui.smallBenefits?.length" v-for="item in ui.smallBenefits" :title="item.text" :icon="item.icon" :format="item.format" />
            </template>

            <template v-else>
                <div v-if="offer.id >= 400 && offer.id <= 499" class="OfferBox__shieldinfo">Cena z tarczy aż do 31.12.2025!</div>

                <OfferBoxParam title="<b>Tarcza przedłużona do końca 2025!*</b>" />

                <OfferBoxParam v-if="offer.type == 'bpm'" title="Potem cena monitorowana i dostosowana do rynku" />
                <OfferBoxParam v-if="nextprice400(offer, 'G11')" :title="'Potem ' + priceformat(nextprice400(offer, 'G11')) + ' zł kWh z VAT'" />
                <OfferBoxParam v-if="nextprice400(offer, 'G12', 1) || nextprice400(offer, 'G12w', 1)" title="Potem według Tabeli cen" />

                <OfferBoxParam v-if="offer.feenextmin != null" :title="'0 zł opłaty handlowej w 2025, później od ' + priceformat(offer.feenextmin, false, offer.feenextmin ? 2 : 0) + ' zł'" />
                <OfferBoxParam v-if="offer.type == 'bpm'" title="Bez zobowiązań - rezygnujesz kiedy chcesz" />
                <OfferBoxParam title="100% zielonej energii" />
            </template>

            <div v-if="legend && (offer.id >= 400 && offer.id <= 499 || offer.id >= 700 && offer.id <= 799)" class="OfferBox__legend">
                *Oferta promocyjna ważna od 01.01.2025 r. Warunki promocji i zasady rezygnacji dostępne w Regulaminie.
            </div>
        </div>
    `,

    props: {
        offer: { type: Object as PropType<OfferJson>, required: true },
        ui: { type: Object as PropType<OfferUi> },
        legend: { type: Boolean, default: true },
    },

    computed: {
        doc_promo() {
            return Links.LINK_DOCS_TERMS_BNS;
        },
    },

    methods: {
        priceformat(price, rounded, r = 3) {
            return Utils.priceFormat(price, rounded, '', r);
        },
    },

    setup(props, ctx) {
        function nextprice400(offer: OfferJson, tariff: OfferTariff, zone?: number): number {
            return OfferUtils.getNextPrice400(offer, tariff, zone);
        }

        return {
            nextprice400,
        };
    },
});

export default defineComponent({
    components: {
        OfferBoxPriceBox,
        OfferBoxWarranty,
        OfferBoxInfo,
    },

    template: `
        <div class="OfferBox" :class="{ 'OfferBox--sticky': stickyclass, ['OfferBox--' + offer.type]: offer.type, 'OfferBox--badge': badge, 'OfferBox--voucher': code }, [ 'OfferBox--' + type, 'OfferBox--' + offer.tariff?.toLowerCase(), 'OfferBox--' + (offer.price_warranty ? offer.price_warranty : '00') ]">
            <div class="OfferBox__wrap">
                <div class="OfferBox__inner">
                    <div class="OfferBox__inner2">
                        <div v-if="cashback && type != 'info'" class="OfferBox__bonus" :class="[ 'OfferBox__bonus--' + cashback ]">
                            <i>+</i>

                            <b>{{ cashback }} zł</b>
                            na start*
                        </div>

                        <div class="OfferBox__content">
                            <div class="OfferBox__head">
                                <div v-if="badge" class="OfferBox__badge">{{ badge_value }}</div>

                                <div class="OfferBox__titles">
                                    <div class="OfferBox__title">{{ offer.title }}</div>
                                </div>

                                <div class="OfferBox__variant">
                                    <div class="OfferBox__badgetariff">
                                        {{ badge_tariff }}
                                    </div>
                                </div>
                            </div>

                            <div v-if="codeitem" class="OfferBox__priceretail">{{ codeitem?.ui.discount?.originalPrice }}</div>

                            <div v-if="!codeitem && [420, 430, 450, 490, 510, 520, 530, 540, 560, 570, 580, 590, 610, 620, 630, 640, 700, 703, 706, 709].includes(offer.id)" class="OfferBox__priceretail">
                                <span v-if="[420, 430, 510, 520, 560, 570, 610, 620, 700, 703].includes(offer.id)">0,739</span>
                                <span v-if="[450, 530, 580, 630, 706].includes(offer.id)">0,729</span>
                                <span v-if="[490, 540, 590, 640, 709].includes(offer.id)">0,719</span>
                                zł/kwh z VAT
                            </div>

                            <OfferBoxPriceBox
                                :offer="offer"
                            />
                        </div>

                        <template v-if="codeitem">
                            <div v-if="codeitem.ui.priceInfo?.text" class="OfferBox__shieldinfo">{{ codeitem.ui.priceInfo?.text }}</div>
                        </template>

                        <template v-if="!codeitem">
                            <div v-if="offer.id >= 400 && offer.id <= 699" class="OfferBox__shieldinfo">Cena z tarczy aż do 31.12.2025!</div>
                            <div v-if="offer.id >= 700 && offer.id <= 799" class="OfferBox__shieldinfo">Cena przez pierwsze 12 miesięcy umowy</div>
                        </template>

                        <OfferBoxWarranty
                            v-if="type != 'info'"
                            :offer="offer"
                            :codeitem="codeitem"
                        />

                        <slot name="select_before"></slot>

                        <div ref="select" class="OfferBox__select">
                            <div class="OfferBox__select-inner">
                                <button type="button" class="button button--primary button--full" :disabled="select_disabled" @click="onClick">{{ select_label }}</button>
                            </div>
                        </div>

                        <OfferBoxInfo
                            :offer="offer"
                            :ui="codeitem?.ui"
                        />

                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    `,

    emits: [
        'click',
    ],

    props: {
        offer: { type: Object as PropType<OfferJson>, required: true },
        type: { type: String, default: Type.FEATURED },

        code: { type: Object as PropType<OfferCode> },

        label_select: { type: String, default: 'Sprawdź Ofertę' },
        label_badge: { type: String, default: 'Polecamy' },

        select_disabled: { type: Boolean, default: false },

        sticky: { type: String as PropType<Sticky> },

        layout_variant: { type: Boolean },
    },

    data() {
        return {
            details: false,
            stickyclass: false,
        };
    },

    computed: {
        offerdiscountperiodtitle() {
            return this.offer.discount_period + ' miesięcy';
        },

        discounttitle() {
            if (!this.offer.discount_title) {
                return null;
            }

            let result = this.offer.discount_title;

            if (this.type != Type.FEATURED && window.innerWidth < 769) {
                result = result.replace('miesięcy', 'm-cy')
            }

            return result;
        },
    },

    mounted() {
        $(document).on('scroll', () => {
            this.recalc();
        });

        $(window).on('resize', () => {
            this.recalc();
        });

        this.recalc();
    },

    methods: {
        recalc() {
            this.stickyclass = false;

            if (this.$refs.select) {
                switch (this.sticky) {
                    case Sticky.AUTO:
                        const st = $(document).scrollTop();

                        const $select = $(this.$refs.select);
                        const top = $select.offset().top;
                        const wh = window.innerHeight;

                        this.stickyclass = st + wh < top;

                        break;

                    case Sticky.ALWAYS:
                        this.stickyclass = true;

                        break;
                }
            }
        },

        async onClick() {
            let ev = ['click'];

            if (this.offer.price_warranty) {
                ev.push(this.offer.price_warranty + 'months');
            } else {
                ev.push('unlimited');
            }

            switch (this.offer.tariff) {
                case OfferTariff.G11:
                    ev.push('classicoffer');
                    break;

                case OfferTariff.G12:
                    ev.push('nightoffer');
                    break;

                case OfferTariff.G12w:
                    ev.push('weekendoffer');
                    break;
            }

            if ($('.vhome').length) {
                ev.push('mainpage');
            } else if ($('.StepOfferDetails').length) {
                ev.push('form');
            } else {
                ev.push('offer');
            }

            await Tracking.doEvent(ev.join('_'));

            this.$emit('click', this.offer);
        },
    },

    setup(props, ctx) {
        const codeitem = computed(() => {
            const item = OfferUtils.getOfferCodeItem(props.code, props.offer.id);

            return item;
        });

        const badge = computed(() => {
            if (codeitem.value) {
                return codeitem.value.ui.campaignTitle?.length > 0;
            } else {
                return props.offer.id == 410 && [Type.FEATURED].includes(props.type as Type);
            }
        });

        const badge_value = computed(() => {
            if (!badge.value) {
                return null;
            }

            if (codeitem.value) {
                return codeitem.value.ui.campaignTitle;
            } else {
                return props.label_badge;
            }
        });

        const badge_tariff = computed(() => {
            if (codeitem.value) {
                return codeitem.value?.ui.badge;
            } else {
                if (props.offer.price_warranty == null) {
                    return 'bezterminowo';
                } else {
                    return 'na ' + Utils.yearsTitle(props.offer.price_warranty);
                }
            }
        });

        const cashback = computed(() => {
            return props.offer.cashback;
        });

        const select_label = computed(() => {
            if (props.code) {
                return 'Odbierz ofertę promocyjną';
            } else {
                return props.label_select;
            }
        });

        return {
            codeitem,
            badge,
            badge_value,
            badge_tariff,
            cashback,
            select_label,
        };
    },
});
